// extracted by css-extract-rspack-plugin
export default {"header":"HhnOthsMzxIsrWjo","back":"asBp6VjiXrwkofTX","backIcon":"J9sWSSYdNVoSAqw6","crumbs":"O2lw1FSPpsQWHRIc"};